module.exports = {"id":"194765","name":"Antoine Griezmann","rating":"88","photo":"./data/images/photos/4/194765.png","club":{"name":"Atlético Madrid","logo":"./data/images/clubs/AtleticoMadrid.png"},"positions":["BU","AD","AG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AntoineGriezmann0.json
// module id = 433
// module chunks = 0